[
  {
    "title": {
      "en": "Cancelling keeps your access until the period ends",
      "el": "Η ακύρωση διατηρεί την πρόσβαση μέχρι το τέλος της περιόδου"
    },
    "version": "2.2.0",
    "date": "2026-10-06",
    "status": "released",
    "description": {
      "en": "When you cancel your subscription you now keep full access, with your plan's quota, until the end of the billing period you have already paid for. The dashboard shows the date your access ends. Cancelling only stops future charges.",
      "el": "Όταν ακυρώνετε τη συνδρομή σας διατηρείτε πλέον πλήρη πρόσβαση, με το όριο του πακέτου σας, μέχρι το τέλος της περιόδου που έχετε ήδη πληρώσει. Ο πίνακας ελέγχου δείχνει την ημερομηνία λήξης της πρόσβασης. Η ακύρωση σταματά μόνο τις μελλοντικές χρεώσεις."
    }
  },
  {
    "title": {
      "en": "ΓΕΜΗ on your PDFs and profession at signup",
      "el": "ΓΕΜΗ στα PDF και επάγγελμα στην εγγραφή"
    },
    "version": "2.1.0",
    "date": "2026-10-06",
    "status": "released",
    "description": {
      "en": "You can now add your ΓΕΜΗ number in Settings and it appears in the company details at the top of your PDF documents. Your profession is now asked in the onboarding form, so you no longer have to fill it in later. Your logo is larger on the PDFs, and saving Settings works again when the B2C alternative provider fields are empty.",
      "el": "Μπορείτε πλέον να προσθέσετε τον αριθμό ΓΕΜΗ στις Ρυθμίσεις και εμφανίζεται στα στοιχεία της επιχείρησης στο πάνω μέρος των PDF παραστατικών σας. Το επάγγελμα ζητείται πλέον στη φόρμα εγγραφής, ώστε να μην χρειάζεται να το συμπληρώσετε αργότερα. Το λογότυπό σας εμφανίζεται μεγαλύτερο στα PDF και η αποθήκευση των Ρυθμίσεων λειτουργεί ξανά όταν τα πεδία εναλλακτικού παρόχου B2C είναι κενά."
    }
  },
  {
    "title": {
      "en": "Correct plan quotas",
      "el": "Σωστό όριο υποβολών ανά πακέτο"
    },
    "version": "2.0.2",
    "date": "2026-10-03",
    "status": "released",
    "description": {
      "en": "Your quota now matches your plan — 30 (Starter), 60 (Professional) or 300 (Growth) submissions per billing cycle — instead of showing 100 for every plan. Usage resets with each Shopify billing cycle, and a mid-cycle upgrade still adds the new plan's submissions on top. As a thank-you for your patience, shops already subscribed before this update keep at least 100 submissions per billing cycle until 31 October 2026.",
      "el": "Το όριο υποβολών αντιστοιχεί πλέον στο πακέτο σας — 30 (Starter), 60 (Professional) ή 300 (Growth) υποβολές ανά κύκλο χρέωσης — αντί για 100 σε όλα τα πακέτα. Ο μετρητής μηδενίζεται σε κάθε κύκλο χρέωσης του Shopify, και η αναβάθμιση μέσα στον κύκλο εξακολουθεί να προσθέτει τις υποβολές του νέου πακέτου. Ως ευχαριστώ για την υπομονή σας, τα καταστήματα που είχαν ήδη ενεργή συνδρομή πριν από αυτή την ενημέρωση διατηρούν τουλάχιστον 100 υποβολές ανά κύκλο χρέωσης έως τις 31 Οκτωβρίου 2026."
    }
  },
  {
    "title": {
      "en": "Subscription status fix",
      "el": "Διόρθωση κατάστασης συνδρομής"
    },
    "version": "2.0.1",
    "date": "2026-10-03",
    "status": "released",
    "description": {
      "en": "Fixed an issue where an active subscription could appear as inactive in the app and ask you to subscribe again. Your Shopify subscription was not interrupted and no extra charges were applied. If you approved the same plan again during this time, it simply replaced your existing subscription, so you were not charged twice.",
      "el": "Διορθώθηκε ένα πρόβλημα όπου μια ενεργή συνδρομή μπορούσε να εμφανίζεται ως ανενεργή στην εφαρμογή και να σας ζητά νέα εγγραφή. Η συνδρομή σας στο Shopify δεν διακόπηκε και δεν εφαρμόστηκαν επιπλέον χρεώσεις. Αν εγκρίνατε ξανά το ίδιο πακέτο σε αυτό το διάστημα, απλώς αντικατέστησε την υπάρχουσα συνδρομή σας, οπότε δεν χρεωθήκατε διπλά."
    }
  },
  {
    "title": {
      "en": "Multiple documents per order",
      "el": "Πολλαπλά παραστατικά ανά παραγγελία"
    },
    "version": "2.0.0",
    "date": "2026-09-22",
    "status": "released",
    "description": {
      "en": "An order can now carry several documents — a delivery note, a receipt, a later invoice, and cancellations of any of those — all listed together with their own status and actions, instead of only ever showing the most recent one. Cancelling one document no longer affects the others.",
      "el": "Μια παραγγελία μπορεί πλέον να έχει πολλαπλά παραστατικά — δελτίο αποστολής, απόδειξη, μεταγενέστερο τιμολόγιο, και ακυρώσεις αυτών — όλα μαζί σε μία λίστα με τη δική τους κατάσταση και ενέργειες, αντί να εμφανίζεται μόνο το πιο πρόσφατο. Η ακύρωση ενός παραστατικού δεν επηρεάζει πλέον τα υπόλοιπα."
    }
  },
  {
    "title": {
      "en": "Consignment and agent sales document types",
      "el": "Παραστατικά παρακαταθήκης και πωλήσεων για λογαριασμό τρίτων"
    },
    "version": "2.0.0",
    "date": "2026-09-22",
    "status": "released",
    "description": {
      "en": "New document types for consignment and agent-sold goods: Sale on Behalf of Third Parties (1.4), Clearance of Sales on Behalf of Third Parties (1.5), and Retail Receipt on Behalf of Third Parties (11.5). \"Sale\" is also now available as a move purpose for a standalone delivery note, for merchants who issue the receipt elsewhere and only submit the goods movement here.",
      "el": "Νέοι τύποι παραστατικών για παρακαταθήκη και πωλήσεις για λογαριασμό τρίτων: Πώληση για Λογαριασμό Τρίτων (1.4), Εκκαθάριση Πωλήσεων για Λογαριασμό Τρίτων (1.5), και Απόδειξη Λιανικής για Λογαριασμό Τρίτων (11.5). Ο λόγος διακίνησης \"Πώληση\" είναι πλέον διαθέσιμος και για αυτόνομο δελτίο αποστολής, για όσους εκδίδουν την απόδειξη αλλού και υποβάλλουν εδώ μόνο τη διακίνηση."
    }
  },
  {
    "title": {
      "en": "VAT category accuracy fix",
      "el": "Διόρθωση κατηγοριών ΦΠΑ"
    },
    "version": "1.9.1",
    "date": "2026-09-15",
    "status": "released",
    "description": {
      "en": "Corrected the AADE VAT category assigned to 9%, 4%, and 17% tax rates on new submissions (older, already-submitted documents are unaffected). Also fixed a rare case where cancelling a document and quickly retrying could create a duplicate cancellation, and where a B2B customer's details could be dropped from a submission if the Shopify order had no shipping address.",
      "el": "Διορθώθηκε η κατηγορία ΦΠΑ ΑΑΔΕ που αντιστοιχίζεται στους συντελεστές 9%, 4% και 17% για νέες υποβολές (παλαιότερα παραστατικά δεν επηρεάζονται). Διορθώθηκε επίσης μια σπάνια περίπτωση όπου η ακύρωση παραστατικού με άμεση επανάληψη μπορούσε να δημιουργήσει διπλή ακύρωση, καθώς και περίπτωση όπου τα στοιχεία πελάτη B2B μπορούσαν να παραλειφθούν αν η παραγγελία Shopify δεν είχε διεύθυνση αποστολής."
    }
  },
  {
    "title": {
      "en": "B2B invoicing and move purpose",
      "el": "Τιμολόγηση B2B και λόγος διακίνησης"
    },
    "version": "1.9.0",
    "date": "2026-09-15",
    "status": "released",
    "description": {
      "en": "Issue B2B sales invoices with counterpart VAT/tax-office/profession details and reusable customer records. Pick the AADE move purpose (sale, consignment, return, free disposal) for delivery documents, add optional notes, and see it all reflected on the generated PDF. Cancelling a B2B invoice now correctly issues a credit invoice instead of failing.",
      "el": "Εκδώστε τιμολόγια πώλησης B2B με στοιχεία ΑΦΜ/ΔΟΥ/επαγγέλματος του παραλήπτη και επαναχρησιμοποιήστε αποθηκευμένους πελάτες. Επιλέξτε τον λόγο διακίνησης ΑΑΔΕ (πώληση, παρακαταθήκη, επιστροφή, δωρεάν διάθεση) για παραστατικά διακίνησης, προσθέστε σχόλια, και δείτε τα όλα στο παραγόμενο PDF. Η ακύρωση τιμολογίου B2B εκδίδει πλέον σωστά πιστωτικό τιμολόγιο αντί να αποτυγχάνει."
    }
  },
  {
    "title": {
      "en": "EU OSS and Non-EU export support",
      "el": "Υποστήριξη EU OSS και εξαγωγών εκτός ΕΕ"
    },
    "version": "1.8.0",
    "date": "2026-09-10",
    "status": "released",
    "description": {
      "en": "Cross-border sales support with EU One-Stop Shop (OSS) and non-EU export VAT handling. Enable in Settings to submit foreign orders with correct VAT exemptions to myDATA.",
      "el": "Υποστήριξη διασυνοριακών πωλήσεων με EU One-Stop Shop (OSS) και εξαγωγές εκτός ΕΕ. Ενεργοποιήστε στις Ρυθμίσεις για να υποβάλετε ξένες παραγγελίες με σωστές απαλλαγές ΦΠΑ."
    }
  },
  {
    "title": {
      "en": "VIP promo codes",
      "el": "Κωδικοί VIP"
    },
    "version": "1.7.0",
    "date": "2026-07-22",
    "status": "released",
    "description": {
      "en": "Got a VIP code? You can now redeem it on the Settings page for bonus free submissions.",
      "el": "Έχετε κωδικό VIP; Τώρα μπορείτε να τον εξαργυρώσετε στις Ρυθμίσεις για επιπλέον δωρεάν υποβολές."
    }
  },
  {
    "title": {
      "en": "Default VAT rate setting",
      "el": "Ρύθμιση προεπιλεγμένου ΦΠΑ"
    },
    "version": "1.5.1",
    "date": "2026-07-14",
    "status": "released",
    "description": {
      "en": "You can now set a default VAT rate in Settings for shops without Shopify tax configuration. This prevents errors when submitting documents to myDATA.",
      "el": "Μπορείτε πλέον να ορίσετε προεπιλεγμένο συντελεστή ΦΠΑ στις Ρυθμίσεις για καταστήματα χωρίς ρύθμιση φόρου στο Shopify. Αυτό αποτρέπει σφάλματα κατά την υποβολή παραστατικών στο myDATA."
    }
  },
  {
    "title": {
      "en": "Payment method selection for receipts",
      "el": "Επιλογή τρόπου πληρωμής για αποδείξεις"
    },
    "version": "1.4.0",
    "date": "2026-05-12",
    "status": "released",
    "description": {
      "en": "You can now select the payment method (Card, Cash, Web Banking, Bank Transfer, On Credit, Other) when submitting receipts to myDATA. The correct payment method is also displayed on PDF documents.",
      "el": "Μπορείτε πλέον να επιλέξετε τον τρόπο πληρωμής (Κάρτα, Μετρητά, Web Banking, Τραπεζική Κατάθεση, Επί Πιστώσει, Λοιπά) κατά την υποβολή αποδείξεων στο myDATA. Ο σωστός τρόπος πληρωμής εμφανίζεται επίσης στα PDF."
    }
  },
  {
    "title": {
      "en": "Added new invoice type: Retail Receipt",
      "el": "Προσθήκη νέου τύπου παραστατικού: Απόδειξη λιανικής"
    },
    "version": "1.3.0",
    "date": "2026-05-06",
    "status": "released",
    "description": {
      "en": "New document type, retail receipt is now avaialble to use",
      "el": "Νέος τύπος παραστατικού για τις αποδείξεις λιανικής πώλησης"
    }
  },
  {
    "title": {
      "en": "Fix: Fixed a bug on the aade endpoint",
      "el": "Διόρθωση στη διεπαφή mydata για νέες εγκατάστάσεις"
    },
    "version": "1.2.0",
    "date": "2026-05-05",
    "status": "released",
    "description": {
      "en": "Fixed an issue on the url of mydata used.",
      "el": "Διορθώθηκε ένα θέμα στη διεπαφή με mydata υπηρεσίες"
    }
  },
  {
    "title": {
      "en": "Fix: Alphanumeric Order Numbers",
      "el": "Διόρθωση: Αλφαριθμητικοί αριθμοί παραγγελίας"
    },
    "version": "1.0.1",
    "date": "2026-03-21",
    "status": "released",
    "description": {
      "en": "Fixed an issue where orders with alphanumeric names (e.g. G8106W) could not be submitted to myDATA.",
      "el": "Διορθώθηκε σφάλμα κατά το οποίο παραγγελίες με αλφαριθμητικά ονόματα (π.χ. G8106W) δεν μπορούσαν να υποβληθούν στο myDATA."
    }
  },
  {
    "title": {
      "en": "Real-time Submission History",
      "el": "Ιστορικό υποβολών σε πραγματικό χρόνο"
    },
    "version": "1.0.0",
    "date": "2025-11-22",
    "status": "released",
    "description": {
      "en": "View the status of all your myDATA submissions in real time.",
      "el": "Δείτε την κατάσταση όλων των υποβολών σας στο myDATA σε πραγματικό χρόνο."
    }
  },
  {
    "title": {
      "en": "PDF Generation with QR Codes",
      "el": "Δημιουργία PDF με κωδικούς QR"
    },
    "version": "1.0.0",
    "date": "2025-11-22",
    "status": "released",
    "description": {
      "en": "Specification-compliant PDF documents including scannable AADE QR codes.",
      "el": "Έγγραφα PDF συμβατά με τις προδιαγραφές, που περιλαμβάνουν σκανάσιμους κωδικούς QR της ΑΑΔΕ."
    }
  },
  {
    "title": {
      "en": "Automatic Delivery Note Submission",
      "el": "Αυτόματη υποβολή δελτίων αποστολής"
    },
    "version": "1.0.0",
    "date": "2025-11-22",
    "status": "released",
    "description": {
      "en": "Instant delivery note submission upon order completion.",
      "el": "Άμεση υποβολή δελτίων αποστολής κατά την ολοκλήρωση της παραγγελίας."
    }
  },
  {
    "title": {
      "en": "Initial myDATA Integration",
      "el": "Αρχική διασύνδεση myDATA"
    },
    "version": "1.0.0",
    "date": "2025-11-22",
    "status": "released",
    "description": {
      "en": "Direct connection to AADE for invoice synchronization.",
      "el": "Απευθείας σύνδεση με την ΑΑΔΕ για το συγχρονισμό τιμολογίων."
    }
  }
]
